import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

const isGcpProject = objectOf({
  project_id: string,
  name: string,
  create_time: maybe(string),
});

export const isGetAlloysGeminiAgenticOauthProjectsResult = objectOf({
  projects: arrayOf(isGcpProject),
});

export const isGetAlloysGeminiAgenticOauthVerifyProjectResult = objectOf({
  gemini_api_enabled: boolean,
  vertex_ai_enabled: boolean,
});

export const isPostAlloysGeminiAgenticOauthConnectResult = objectOf({
  authorization_url: string,
});

export const isPostAlloysGeminiAgenticOauthSelectProjectResult = objectOf({
  integration: objectOf({}),
});

export const isDeleteAlloysGeminiAgenticOauthDisconnectResult = objectOf({});
